import { createBrowserRouter } from "react-router-dom";
import Login from "../containers/auth/Login";
import NotFound from "../pages/NotFound";
import ProtectedRoute from "../redux/hooks/ProtectedRoute";
import HomePage from "../pages/HomePage";
import { ROLE } from "./roles";
import CreateUser from "../pages/user/create";
import EditUser from "../pages/user/edit";
import VerifyPayment from "../pages/payment/PaymentVerify";
import UserList from "../pages/user/list";
import AddBankPage from "../containers/bank/AddBankPage";
import PaymentList from "../pages/payment/PaymentList";

const router = createBrowserRouter([
    {
        path: '/',
        element: (<ProtectedRoute roles={[ROLE.Admin]}>
            <HomePage />
        </ProtectedRoute >
        )
    },
    {
        path: '/login',
        element: <Login />
    },
    {
        path: '/user/create',
        element: <CreateUser />
    },
    {
        path: '/user/edit/:id',
        element: <EditUser />
    },
    {
        path: '/user/list',
        element: <UserList />
    },
    {
        path: '/payment/verify',
        element: <VerifyPayment />
    },
    {
        path: '/payment/list',
        element: <ProtectedRoute roles={[ROLE.User]}><PaymentList /></ProtectedRoute>
    },
    {
        path: '/bank/add',
        element: <AddBankPage />
    },
    {
        path: '*',
        element: <NotFound />
    }
])

export default router